<template>
  <section>
    <div class="container is-fluid">
      <h2 class="mb-1 half-top-section">Nuestros clientes /</h2>
      <grid-photo :list="list" />
    </div>
  </section>
</template>

<script>
import GridPhoto from "@/components/GridPhoto";
import list from "@/data/customers.json";

export default {
  name: "Home",
  components: {
    GridPhoto
  },
  data() {
    return { list };
  }
};
</script>
